import { render, staticRenderFns } from "./OnboardingSteps.vue?vue&type=template&id=3e1094c4&"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js&"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports